const config = {
    API_URL: "https://testapi.glassyfied.com",
    QUERY_DEV_TOOLS_ENABLED: false,
    MAX_MESSAGES: 100,
    SOCKET_CONNECTION_INDICATOR_ENABLED: false,
    SOCKET_CONNECTION_URL: "wss://testapi.glassyfied.com/ws",
    SECRET_KEY: "TestEncryptionKey",
};

export default config;
